import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

const Modal = ({ show, onClose, title, children, fullscreen = false }) => {
    // Prevent background scroll when modal is open
    useEffect(() => {
        if (!show) return;
        const prev = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => { document.body.style.overflow = prev; };
    }, [show]);
    if (!show) return null;

    const containerClasses = fullscreen
        ? 'login-container relative z-10 w-screen h-screen rounded-none flex flex-col'
        : 'login-container relative z-10 w-full max-w-[95vw] sm:max-w-2xl rounded-2xl flex flex-col max-h-[90vh]';

    const overlay = (
        <div className="fixed inset-0 z-[1000] bg-black bg-opacity-70 backdrop-blur-sm" onClick={onClose}>
            <div className="min-h-[100vh] flex items-start justify-center p-4">
                <div className={containerClasses} onClick={e => e.stopPropagation()}>
                    <div className="flex-shrink-0 p-4 sm:p-6 border-b border-sky-500/20 flex justify-between items-center">
                        <h3 className="text-lg sm:text-xl font-semibold text-sky-300">{title}</h3>
                        <button onClick={onClose} className="text-gray-400 hover:text-white text-2xl">&times;</button>
                    </div>
                    <div className="p-4 sm:p-6 overflow-y-auto flex-1 w-full">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );

    return ReactDOM.createPortal(overlay, document.body);
};

export default Modal;
